import filterConstants from '../constants';

const reportsProgressStatuses = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsProgressStatuses,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
  },
});

export default reportsProgressStatuses;
